export default __webpack_public_path__ + "static/media/marketing-campaigns.d8c9ced3.svg";